import { render, staticRenderFns } from "./SidebarContactDetailsBlock.vue?vue&type=template&id=683cd8b2&scoped=true"
import script from "./SidebarContactDetailsBlock.vue?vue&type=script&lang=ts"
export * from "./SidebarContactDetailsBlock.vue?vue&type=script&lang=ts"
import style0 from "./SidebarContactDetailsBlock.vue?vue&type=style&index=0&id=683cd8b2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683cd8b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('683cd8b2')) {
      api.createRecord('683cd8b2', component.options)
    } else {
      api.reload('683cd8b2', component.options)
    }
    module.hot.accept("./SidebarContactDetailsBlock.vue?vue&type=template&id=683cd8b2&scoped=true", function () {
      api.rerender('683cd8b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/sidebar/SidebarContactDetailsBlock.vue"
export default component.exports